<div class="scrollable-table padding-20">
  <h1>ACH Records</h1>
  <table mat-table [dataSource]="achRecords" class="mat-elevation-z8">
      <ng-container matColumnDef="Bank Name">
          <th mat-header-cell *matHeaderCellDef>Bank Name</th>
          <td mat-cell *matCellDef="let element"> {{element.bankName}} </td>
        </ng-container>
      
        <!-- Name Column -->
        <ng-container matColumnDef="Account Number">
          <th mat-header-cell *matHeaderCellDef>Account Number</th>
          <td mat-cell *matCellDef="let element">
            <div class="flex-row" style="align-items: center;">
              <div>{{element.accountNumber}}</div>
              <button mat-icon-button [cdkCopyToClipboard]="element.accountNumber">
                  <mat-icon >content_copy</mat-icon>
              </button>
            </div>
          </td>
        </ng-container>
      
        <!-- Weight Column -->
        <ng-container matColumnDef="Routing Number">
          <th mat-header-cell *matHeaderCellDef>Routing Number</th>
            <td mat-cell *matCellDef="let element">
            <div class="flex-row" style="align-items: center;">
              <div>{{element.routingNumber}}</div>
              <button mat-icon-button [cdkCopyToClipboard]="element.routingNumber">
                  <mat-icon >content_copy</mat-icon>
              </button>
            </div>
          </td>
        </ng-container>

        <!-- Symbol Column -->
        <ng-container matColumnDef="Create Date">
          <th mat-header-cell *matHeaderCellDef>Create Date</th>
          <td mat-cell *matCellDef="let element"> {{element.createDateUTC | date:'medium'}} </td>
        </ng-container>
      
        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>

        <tr class="mat-row" *matNoDataRow>
          <td class="mat-cell" colspan="4">No ACH Records found.</td>
      </tr>
  </table>
</div> 